import { Box, Card, Skeleton } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { ReactNode } from 'react';

export const HPSummarySectionCard = (props: {
  loading?: boolean;
  children: ReactNode;
}) => {
  return (
    <ErrorBoundary identifier="HPSummarySectionCard">
      <Skeleton loading={!!props.loading}>
        <Card className="no-background" style={{ padding: 0 }}>
          <Box p="5" height="100%">
            {props.children}
          </Box>
        </Card>
      </Skeleton>
    </ErrorBoundary>
  );
};
